/* ==================================================================
   BAKOS — product page widgets
   Pickup card, size guide modal. The delivery estimate lives in its
   own file because it is the only one with real logic in it.
   ================================================================== */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, flag) {
    if (el.dataset[flag] === 'on') return false;
    el.dataset[flag] = 'on';
    return true;
  }

  /* =================================================================
     1. PICK-UP IN STORE
     ================================================================= */
  function initPickup(root) {
    if (!once(root, 'bakosPickup')) return;

    var toggle = $('[data-bakos-pickup-toggle]', root);
    var panel = $('[data-bakos-pickup-panel]', root);
    var statusText = $('[data-bakos-pickup-status-text]', root);
    var sub = $('[data-bakos-pickup-sub]', root);

    /* --- open / close --- */
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    }

    /* --- follow the selected variant --- */
    var data = {};
    var payload = $('[data-bakos-pickup-data]', root);
    if (payload) { try { data = JSON.parse(payload.textContent); } catch (err) { data = {}; } }

    var availableText = statusText ? statusText.textContent.trim() : '';
    var strings = {
      available: root.dataset.availableText || availableText,
      unavailable: root.dataset.unavailableText || ''
    };

    // capture the two phrasings from the markup the first time
    var section = root.closest('[data-ckls-section]') || document;

    function render(info) {
      root.classList.toggle('bakos-pickup--out', !info.available);

      if (statusText) {
        var av = root.getAttribute('data-text-available');
        var un = root.getAttribute('data-text-unavailable');
        if (av && un) statusText.textContent = info.available ? av : un;
      }
      if (sub && info.location) {
        var base = sub.textContent.split('·')[0].trim();
        sub.textContent = base + ' · ' + info.location;
      }
    }

    // Shopify only exposes store availability for the variant a page is
    // rendered with, so unknown sizes are fetched by re-rendering this
    // section for that variant and reading its pickup JSON.
    var shopifySection = root.closest('[id^="shopify-section-"]');
    var sectionId = shopifySection ? shopifySection.id.replace('shopify-section-', '') : '';
    var pending = {};

    function resolve(v) {
      if (!sectionId || !v.url || pending[v.id]) return;
      pending[v.id] = true;
      var url = v.url + (v.url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('[data-bakos-pickup-data]');
          if (!node) return;
          var fresh = JSON.parse(node.textContent)[v.id];
          if (!fresh || fresh.available === null) return;
          data[v.id] = fresh;
          if (current === v.id) render(fresh);
        })
        .catch(function () {})
        .then(function () { pending[v.id] = false; });
    }

    var current = null;
    section.addEventListener('ckls:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      current = v.id;
      var info = data[v.id];
      if (!info) return;

      if (info.available === null) {
        // until the real answer arrives, follow online stock: this store
        // ships from the shop, so in stock online means in the shop
        render({ available: !!v.available, location: '' });
        resolve(v);
        return;
      }
      render(info);
    });
  }

  /* =================================================================
     2. SIZE GUIDE MODAL

     The content is usually rendered server-side. The fetch path only
     runs when the page could not be resolved at render time (a guide
     chosen per product via metafield, say), and it is deliberately
     forgiving: any failure falls back to simply following the link.
     ================================================================= */
  function initSizeGuide(scope) {
    $$('[data-bakos-sizeguide-open]', scope).forEach(function (trigger) {
      if (!once(trigger, 'bakosSg')) return;

      var dialog = $('[data-bakos-sizeguide]', trigger.closest('[data-ckls-section]') || document);
      if (!dialog || typeof dialog.showModal !== 'function') return; // no <dialog>: the link still works

      var body = $('[data-bakos-sizeguide-body]', dialog);
      var loaded = !$('[data-bakos-sizeguide-loading]', dialog);
      var lastFocus = null;

      function open(e) {
        e.preventDefault();
        lastFocus = document.activeElement;
        dialog.showModal();

        if (loaded) return;
        loaded = true;
        fetch(trigger.dataset.pageUrl, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var content = doc.querySelector('.page-content, main .rte, main article, main');
            if (!content) throw new Error('no content');
            body.innerHTML = '<div class="bakos-sizeguide__scroller">' + content.innerHTML + '</div>';
          })
          .catch(function () {
            // give the customer the page rather than an error box
            dialog.close();
            window.location.href = trigger.href;
          });
      }

      trigger.addEventListener('click', open);

      var close = $('[data-bakos-sizeguide-close]', dialog);
      if (close) close.addEventListener('click', function () { dialog.close(); });

      // click outside the panel closes it
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', function () {
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      });
    });
  }

  /* =================================================================
     BOOT
     ================================================================= */
  function boot(scope) {
    var ctx = scope || document;
    $$('[data-bakos-pickup]', ctx).forEach(initPickup);
    initSizeGuide(ctx);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
